import { render, staticRenderFns } from "./distributorpurchaseinboundreport.vue?vue&type=template&id=51ee26ca&scoped=true&"
import script from "./distributorpurchaseinboundreport.vue?vue&type=script&lang=js&"
export * from "./distributorpurchaseinboundreport.vue?vue&type=script&lang=js&"
import style0 from "./distributorpurchaseinboundreport.vue?vue&type=style&index=0&id=51ee26ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ee26ca",
  null
  
)

export default component.exports